import { applyBrowserDefaultAudioOutput } from '~/hooks/janus/webDevices';

export async function recoverRemotePlayback(
  audioEl: HTMLMediaElement | null,
  remoteStream: MediaStream | null,
  muted = false
): Promise<boolean> {
  if (!audioEl || !remoteStream) return false;

  try {
    await applyBrowserDefaultAudioOutput(audioEl);
    audioEl.srcObject = remoteStream;
    audioEl.muted = muted;
    audioEl.volume = 1;
    await audioEl.play();
    return true;
  } catch {
    return false;
  }
}
